// react
import React, { useState } from 'react';

// third-party
import { Link } from 'react-router-dom';

// application
import Megamenu from './Megamenu';
import Menu from './Menu';
import { ArrowRoundedRight6x9Svg } from '../../svg';

// data stubs
// import departments from '../../data/headerDepartments';

function DepartmentsLinks(props) {
    const departments = props.dept || [];
    const [openIndex, setOpenIndex] = useState(null);
    const linksList = departments.map((department, index) => {
        let arrow = null;
        let submenu = null;
        let itemClass = '';

        if (department.submenu) {
            arrow = <ArrowRoundedRight6x9Svg className="departments__link-arrow" />;
        }

        if (department.submenu && department.submenu.type === 'menu') {
            itemClass = 'departments__item--menu';
            submenu = (
                <div className="departments__menu">
                    <Menu items={department.submenu.menu} onClick={props.menuClose}/>
                </div>
            );
        }

        if (department.submenu && department.submenu.type === 'megamenu') {
            submenu = (
                <div className={`departments__megamenu departments__megamenu--${department.submenu.menu.size}`}>
                    <Megamenu menu={department.submenu.menu} location="department" />
                </div>
            );
        }

        return (
            <li key={index} className={`departments__item ${itemClass} ${openIndex === index ? 'departments__item--open' : ''}`}>
                <Link
                    to={department.url || '#'}
                    onClick={(event) => {
                        if (department.submenu) {
                            event.preventDefault();
                            setOpenIndex(openIndex === index ? null : index);
                        } else {
                            props.menuClose();
                        }
                    }}
                    aria-expanded={department.submenu ? openIndex === index : undefined}
                >
                    {department.title}
                    {arrow}
                </Link>
                {submenu}
            </li>
        );
    });

    return (
        <ul className="departments__links">
            {linksList}
        </ul>
    );
}

export default DepartmentsLinks;
